import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { HttpParams } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, last, map, tap } from 'rxjs/operators';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
}

const BASE_API_URL = '';

@Injectable({
  providedIn: 'root'
})
export class PurchaseIpService {
  constructor(private http: HttpClient) {

  }

  getChargeByCategoryIp(): Observable<any> {
    const get_url = BASE_API_URL + 'charge/ByCategory/IP';
    return this.http.get<any>(get_url,{ headers: httpOptions.headers}).pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }
  getChargeVAS(): Observable<any> {
    const get_url = BASE_API_URL + 'charge/getVASCharges';
    return this.http.get<any>(get_url,{ headers: httpOptions.headers}).pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }
  savePurchaseIp(ip_data): Observable<any> {
    const get_url = BASE_API_URL + 'subscriber/applyCharge';
    return this.http.post<any>(get_url,ip_data,{ headers: httpOptions.headers}).pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }

}
